function isValidDate(date: unknown) {
  return (
    date &&
    Object.prototype.toString.call(date) === "[object Date]" &&
    !Number.isNaN(date as number)
  );
}

export default isValidDate;
